/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DevelopmentalProvisionPlanAiResponseDto } from '../models/developmental-provision-plan-ai-response-dto';
import { DevelopmentalReportAiResponseDto } from '../models/developmental-report-ai-response-dto';
import { documentAiControllerAiDataBasedGeneration } from '../fn/document-ai/document-ai-controller-ai-data-based-generation';
import { DocumentAiControllerAiDataBasedGeneration$Params } from '../fn/document-ai/document-ai-controller-ai-data-based-generation';
import { documentAiControllerAiEnhancement } from '../fn/document-ai/document-ai-controller-ai-enhancement';
import { DocumentAiControllerAiEnhancement$Params } from '../fn/document-ai/document-ai-controller-ai-enhancement';
import { documentAiControllerDevelopmentalProvisionPlanAi } from '../fn/document-ai/document-ai-controller-developmental-provision-plan-ai';
import { DocumentAiControllerDevelopmentalProvisionPlanAi$Params } from '../fn/document-ai/document-ai-controller-developmental-provision-plan-ai';
import { documentAiControllerDevelopmentalReportAi } from '../fn/document-ai/document-ai-controller-developmental-report-ai';
import { DocumentAiControllerDevelopmentalReportAi$Params } from '../fn/document-ai/document-ai-controller-developmental-report-ai';
import { documentAiControllerEvaluationReportAi } from '../fn/document-ai/document-ai-controller-evaluation-report-ai';
import { DocumentAiControllerEvaluationReportAi$Params } from '../fn/document-ai/document-ai-controller-evaluation-report-ai';
import { documentAiControllerFirstCounselingAi } from '../fn/document-ai/document-ai-controller-first-counseling-ai';
import { DocumentAiControllerFirstCounselingAi$Params } from '../fn/document-ai/document-ai-controller-first-counseling-ai';
import { documentAiControllerServiceEndReportAi } from '../fn/document-ai/document-ai-controller-service-end-report-ai';
import { DocumentAiControllerServiceEndReportAi$Params } from '../fn/document-ai/document-ai-controller-service-end-report-ai';
import { documentAiControllerServiceInspectionReportAi } from '../fn/document-ai/document-ai-controller-service-inspection-report-ai';
import { DocumentAiControllerServiceInspectionReportAi$Params } from '../fn/document-ai/document-ai-controller-service-inspection-report-ai';
import { EvaluationReportAiResponseDto } from '../models/evaluation-report-ai-response-dto';
import { FirstCounselingAiResponseDto } from '../models/first-counseling-ai-response-dto';
import { GeneralAiResponseDto } from '../models/general-ai-response-dto';
import { ServiceEndReportAiResponseDto } from '../models/service-end-report-ai-response-dto';
import { ServiceInspectionReportAiResponseDto } from '../models/service-inspection-report-ai-response-dto';

@Injectable({ providedIn: 'root' })
export class DocumentAiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `documentAiControllerAiEnhancement()` */
  static readonly DocumentAiControllerAiEnhancementPath = '/api/document-ai/ai-enhancement';

  /**
   * 항목에 대한 사용자의 입력 내용을 바탕으로 내용을 증강 생성 합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentAiControllerAiEnhancement()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiControllerAiEnhancement$Response(params: DocumentAiControllerAiEnhancement$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneralAiResponseDto>> {
    return documentAiControllerAiEnhancement(this.http, this.rootUrl, params, context);
  }

  /**
   * 항목에 대한 사용자의 입력 내용을 바탕으로 내용을 증강 생성 합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentAiControllerAiEnhancement$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiControllerAiEnhancement(params: DocumentAiControllerAiEnhancement$Params, context?: HttpContext): Observable<GeneralAiResponseDto> {
    return this.documentAiControllerAiEnhancement$Response(params, context).pipe(
      map((r: StrictHttpResponse<GeneralAiResponseDto>): GeneralAiResponseDto => r.body)
    );
  }

  /** Path part for operation `documentAiControllerAiDataBasedGeneration()` */
  static readonly DocumentAiControllerAiDataBasedGenerationPath = '/api/document-ai/ai-data-based-generation';

  /**
   * 데이터 기반 AI 생성
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentAiControllerAiDataBasedGeneration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiControllerAiDataBasedGeneration$Response(params: DocumentAiControllerAiDataBasedGeneration$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneralAiResponseDto>> {
    return documentAiControllerAiDataBasedGeneration(this.http, this.rootUrl, params, context);
  }

  /**
   * 데이터 기반 AI 생성
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentAiControllerAiDataBasedGeneration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiControllerAiDataBasedGeneration(params: DocumentAiControllerAiDataBasedGeneration$Params, context?: HttpContext): Observable<GeneralAiResponseDto> {
    return this.documentAiControllerAiDataBasedGeneration$Response(params, context).pipe(
      map((r: StrictHttpResponse<GeneralAiResponseDto>): GeneralAiResponseDto => r.body)
    );
  }

  /** Path part for operation `documentAiControllerFirstCounselingAi()` */
  static readonly DocumentAiControllerFirstCounselingAiPath = '/api/document-ai/first-counseling-ai';

  /**
   * 초기상담 AI 생성
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentAiControllerFirstCounselingAi()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiControllerFirstCounselingAi$Response(params: DocumentAiControllerFirstCounselingAi$Params, context?: HttpContext): Observable<StrictHttpResponse<FirstCounselingAiResponseDto>> {
    return documentAiControllerFirstCounselingAi(this.http, this.rootUrl, params, context);
  }

  /**
   * 초기상담 AI 생성
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentAiControllerFirstCounselingAi$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiControllerFirstCounselingAi(params: DocumentAiControllerFirstCounselingAi$Params, context?: HttpContext): Observable<FirstCounselingAiResponseDto> {
    return this.documentAiControllerFirstCounselingAi$Response(params, context).pipe(
      map((r: StrictHttpResponse<FirstCounselingAiResponseDto>): FirstCounselingAiResponseDto => r.body)
    );
  }

  /** Path part for operation `documentAiControllerEvaluationReportAi()` */
  static readonly DocumentAiControllerEvaluationReportAiPath = '/api/document-ai/evaluation-report-ai/{ticketId}';

  /**
   * 평가(진단)보고서 AI 생성
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentAiControllerEvaluationReportAi()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiControllerEvaluationReportAi$Response(params: DocumentAiControllerEvaluationReportAi$Params, context?: HttpContext): Observable<StrictHttpResponse<EvaluationReportAiResponseDto>> {
    return documentAiControllerEvaluationReportAi(this.http, this.rootUrl, params, context);
  }

  /**
   * 평가(진단)보고서 AI 생성
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentAiControllerEvaluationReportAi$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiControllerEvaluationReportAi(params: DocumentAiControllerEvaluationReportAi$Params, context?: HttpContext): Observable<EvaluationReportAiResponseDto> {
    return this.documentAiControllerEvaluationReportAi$Response(params, context).pipe(
      map((r: StrictHttpResponse<EvaluationReportAiResponseDto>): EvaluationReportAiResponseDto => r.body)
    );
  }

  /** Path part for operation `documentAiControllerDevelopmentalProvisionPlanAi()` */
  static readonly DocumentAiControllerDevelopmentalProvisionPlanAiPath = '/api/document-ai/developmental-provision-plan-ai/{ticketId}';

  /**
   * 발달재활 제공(이용)계획서 AI 생성
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentAiControllerDevelopmentalProvisionPlanAi()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiControllerDevelopmentalProvisionPlanAi$Response(params: DocumentAiControllerDevelopmentalProvisionPlanAi$Params, context?: HttpContext): Observable<StrictHttpResponse<DevelopmentalProvisionPlanAiResponseDto>> {
    return documentAiControllerDevelopmentalProvisionPlanAi(this.http, this.rootUrl, params, context);
  }

  /**
   * 발달재활 제공(이용)계획서 AI 생성
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentAiControllerDevelopmentalProvisionPlanAi$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiControllerDevelopmentalProvisionPlanAi(params: DocumentAiControllerDevelopmentalProvisionPlanAi$Params, context?: HttpContext): Observable<DevelopmentalProvisionPlanAiResponseDto> {
    return this.documentAiControllerDevelopmentalProvisionPlanAi$Response(params, context).pipe(
      map((r: StrictHttpResponse<DevelopmentalProvisionPlanAiResponseDto>): DevelopmentalProvisionPlanAiResponseDto => r.body)
    );
  }

  /** Path part for operation `documentAiControllerDevelopmentalReportAi()` */
  static readonly DocumentAiControllerDevelopmentalReportAiPath = '/api/document-ai/developmental-report-ai/{ticketId}';

  /**
   * 발달재활 중간 / 종결 보고서 AI 생성
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentAiControllerDevelopmentalReportAi()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiControllerDevelopmentalReportAi$Response(params: DocumentAiControllerDevelopmentalReportAi$Params, context?: HttpContext): Observable<StrictHttpResponse<DevelopmentalReportAiResponseDto>> {
    return documentAiControllerDevelopmentalReportAi(this.http, this.rootUrl, params, context);
  }

  /**
   * 발달재활 중간 / 종결 보고서 AI 생성
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentAiControllerDevelopmentalReportAi$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiControllerDevelopmentalReportAi(params: DocumentAiControllerDevelopmentalReportAi$Params, context?: HttpContext): Observable<DevelopmentalReportAiResponseDto> {
    return this.documentAiControllerDevelopmentalReportAi$Response(params, context).pipe(
      map((r: StrictHttpResponse<DevelopmentalReportAiResponseDto>): DevelopmentalReportAiResponseDto => r.body)
    );
  }

  /** Path part for operation `documentAiControllerServiceInspectionReportAi()` */
  static readonly DocumentAiControllerServiceInspectionReportAiPath = '/api/document-ai/service-inspection-report-ai/{ticketId}';

  /**
   * 서비스 점검 보고서 AI 생성
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentAiControllerServiceInspectionReportAi()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiControllerServiceInspectionReportAi$Response(params: DocumentAiControllerServiceInspectionReportAi$Params, context?: HttpContext): Observable<StrictHttpResponse<ServiceInspectionReportAiResponseDto>> {
    return documentAiControllerServiceInspectionReportAi(this.http, this.rootUrl, params, context);
  }

  /**
   * 서비스 점검 보고서 AI 생성
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentAiControllerServiceInspectionReportAi$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiControllerServiceInspectionReportAi(params: DocumentAiControllerServiceInspectionReportAi$Params, context?: HttpContext): Observable<ServiceInspectionReportAiResponseDto> {
    return this.documentAiControllerServiceInspectionReportAi$Response(params, context).pipe(
      map((r: StrictHttpResponse<ServiceInspectionReportAiResponseDto>): ServiceInspectionReportAiResponseDto => r.body)
    );
  }

  /** Path part for operation `documentAiControllerServiceEndReportAi()` */
  static readonly DocumentAiControllerServiceEndReportAiPath = '/api/document-ai/service-end-report-ai/{ticketId}';

  /**
   * 서비스 종료 보고서 AI 생성
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentAiControllerServiceEndReportAi()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiControllerServiceEndReportAi$Response(params: DocumentAiControllerServiceEndReportAi$Params, context?: HttpContext): Observable<StrictHttpResponse<ServiceEndReportAiResponseDto>> {
    return documentAiControllerServiceEndReportAi(this.http, this.rootUrl, params, context);
  }

  /**
   * 서비스 종료 보고서 AI 생성
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentAiControllerServiceEndReportAi$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiControllerServiceEndReportAi(params: DocumentAiControllerServiceEndReportAi$Params, context?: HttpContext): Observable<ServiceEndReportAiResponseDto> {
    return this.documentAiControllerServiceEndReportAi$Response(params, context).pipe(
      map((r: StrictHttpResponse<ServiceEndReportAiResponseDto>): ServiceEndReportAiResponseDto => r.body)
    );
  }

}
